import React from "react";
import styles from "./UrlProcessor.module.css"
import {Section} from "../../../../../../elements/section/Section";
import {FullBotUi} from "../../../../../../../api/generated";
import {TextFieldsLine} from "../../../../../../elements/textFieldsLine/TextFieldsLine";
import {getMatchFieldName, getMatchTypeName} from "../../../../modal/createAndUpdate/components/util/urlProcessorUtil";

interface UrlProcessorProps {
    bot: FullBotUi
}

export const UrlProcessor: React.FC<UrlProcessorProps> = ({
                                                              bot
                                                          }) => {
    return <Section title={"URL processor"}>
        <div className={styles.fieldsWrapper}>
            <TextFieldsLine
                leftFieldTitle={"Processor enabled"}
                leftFieldValue={bot.urlProcessorEnabled ? "Enabled" : "Disabled"}
                rightFieldTitle={"Match Field"}
                rightFieldValue={bot.matchField && bot.urlProcessorEnabled ? getMatchFieldName(bot.matchField) : "—"}
            />
            <TextFieldsLine
                leftFieldTitle={"Match Type"}
                leftFieldValue={bot.matchType && bot.urlProcessorEnabled ? getMatchTypeName(bot.matchType) : "—"}
                rightFieldTitle={"Segment Number From The End"}
                rightFieldValue={bot.urlProcessorEnabled ? bot.segmentNumberFromTheEnd : "—"}
            />
        </div>
    </Section>
}
